import React, { memo, useContext } from 'react';
import { ScrollLink } from '@prisjakt/ui-scroll';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { noop } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import { getScrollLinkOffset } from '../../../utils';

const LinkToPriceHistory = ({ children, routeSection, product, onClick }) => {
  const { linkTo, t } = useContext(AppContext);
  return routeSection === 'statistics' ? (
    <ScrollLink
      to="Product Information"
      calculateOffset={getScrollLinkOffset}
      onClick={onClick}
    >
      {children}
    </ScrollLink>
  ) : (
    <Link
      to={linkTo('productPriceHistory', product)}
      onClick={onClick}
      aria-label={t('product', 'tabs.price-history')}
    >
      {children}
    </Link>
  );
};

LinkToPriceHistory.defaultProps = {
  children: null,
  routeSection: null,
  product: null,
  onClick: noop,
};

LinkToPriceHistory.propTypes = {
  children: PropTypes.node,
  routeSection: PropTypes.string,
  product: PropTypes.object,
  onClick: PropTypes.func,
};

export default memo(LinkToPriceHistory);
